<ng-template #tipContent>
  Sub-Classification: <b>{{subClassification}}</b>
</ng-template>
<span tooltipClass="search-tooltip" (mouseover)="openTip(tip)" (mouseleave)="closeTip(tip)" [ngbTooltip]="tipContent" #tip="ngbTooltip" triggers="manual" container="body">
  {{item.ItemTitle}}
</span>

